import { Dialog } from "@reach/dialog";
import { Cross } from "./Icons";

const Modal = ({ modal, setModal, children, ariaText }) => {
  return (
    <Dialog
      isOpen={modal}
      onDismiss={() => setModal(false)}
      aria-label={ariaText}
      className="z-50 fade-in fixed inset-0 flex items-center justify-center"
      style={{ backdropFilter: "blur(4px)" }}
    >
      <div className="bg-white rounded-lg shadow-2xl p-4 max-w-[80%] w-full">
        <div className="flex justify-end">
          <div onClick={() => setModal(false)}>
            <div className="p-1.5 hover:bg-red-200 rounded-full text-red-900">
              <Cross />
            </div>
          </div>
        </div>
        {children}
      </div>
    </Dialog>
  );
};

export default Modal;
